// Table column definitions for Soft Tag Manager tags list
import type { CreateSearchTagListResponse } from '@/features/tags/types/tags.types';
import { createColumnHelper } from '@tanstack/react-table';
import { IconButton, Tooltip } from '@yaradigitallabs/ahua-react';
import { copyToClipboard } from '@/utils/clipboard';
import React from 'react';
import { showCopyToast } from '../utils/helpers';

// Helper for creating column definitions with type safety
const columnHelper = createColumnHelper<CreateSearchTagListResponse>();

export const columns = [
  // Example: Checkbox column for row selection (commented out)
  // columnHelper.display({ ... })
  // Production Site column
  columnHelper.accessor('type', {
    header: () => 'Type',
    cell: info => {
      return (
        <div className="w-30">
          <Tooltip concept="inverse" text={info.getValue()} tipVisibility>
            <div className="truncate">{info.getValue()}</div>
          </Tooltip>
        </div>
      );
    },
    size: 128,
  }),
  //  Area column
  columnHelper.accessor('name', {
    header: () => 'Name',
    cell: info => {
      return (
        <div className="w-40">
          <Tooltip concept="inverse" text={info.getValue()} tipVisibility>
            <div className="truncate">{info.getValue()}</div>
          </Tooltip>
        </div>
      );
    },
    size: 128,
  }),
  // Production Line column
  columnHelper.accessor('id', {
    header: () => 'ID',
    cell: info => {
      return (
        <div className="w-60">
          <Tooltip concept="inverse" text={info.getValue()} tipVisibility>
            <div className="truncate">{info.getValue()}</div>
          </Tooltip>
        </div>
      );
    },
    size: 160,
  }),
  // Soft Tag Name column
  columnHelper.accessor('source', {
    header: () => 'Source',
    cell: info => <div className="w-10 truncate">{info.getValue()}</div>,
    size: 256,
  }),
  columnHelper.accessor('menu', {
    header: () => '',
    cell: info => {
      const name = info.row.original.name;
      const type = info.row.original.type;
      const id = info.row.original.id;
      // Handler to copy name to clipboard and show toast
      const handleCopy = async (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
      ) => {
        if (name && type && id) {
          try {
            const successMessage = `(tag_name="${name}", timeseries_id="${id}")`; //Example: (tag_name="CO2_B131.PIC01101", timeseries_id="ef138f99-9981-429b-9d71-78b7a91f0df8")
            const success = await copyToClipboard(successMessage);
            const container = e.currentTarget.parentElement as HTMLDivElement;
            if (container) {
              if (success) {
                showCopyToast(container, 'Copied', false);
              } else {
                showCopyToast(container, 'Copy failed', true);
                console.warn('Failed to copy to clipboard');
              }
            }
          } catch (error) {
            console.error('Copy operation failed:', error);
            const container = e.currentTarget.parentElement as HTMLDivElement;
            if (container) {
              showCopyToast(container, 'Copy error', true);
            }
          }
        }
      };
      return (
        <div style={{ position: 'relative' }}>
          <IconButton
            colorConcept="brand"
            icon="Copy"
            onClick={handleCopy}
            size="xs"
            type="filled"
          />
        </div>
      );
    },
    size: 256,
  }),
];
